import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

  constructor() {
    //intentionally left space for future use
  }

  ngOnInit(): void {
    //intentionally left space for future use

  }

}
